import { useQuery } from "react-query";
import { getForReviewInvoiceCount } from "../../../../../actions/CarrierAgreementMgmt/VendorInvoice";

const useGetForReviewInvoiceCount = () => {
  return useQuery("GetForReviewInvoiceCount", getForReviewInvoiceCount, {
    refetchOnWindowFocus: false,
  });
};

export default useGetForReviewInvoiceCount;
